import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import NotaryListContainer from "../../../components/nominee/NotaryList/NotaryListContainer";

const NotariesScene = ({ t }: WithTranslation) => {
  return <NotaryListContainer />;
};

export default withTranslation("header")(NotariesScene);
